import * as Blockly from "blockly/core";

export const RidersDark: any = (isZelos: boolean) => {
  return {
    name: "riders-dark",
    base: isZelos ? Blockly.Themes.Zelos : Blockly.Themes.Classic,

    blockStyles: isZelos
      ? {
          math_blocks: {
            colourPrimary: "rgb(193, 70, 197)",
            colourSecondary: "rgb(187, 49, 189)",
            colourTertiary: "rgb(187, 49, 189)",
          },
        }
      : {},
    categoryStyles: {
      logic_category: {
        colour: "rgb(61, 128, 254)",
      },
      boolean_category: {
        colour: "rgb(61, 128, 254)",
      },
      loops_category: {
        colour: "rgb(29, 178, 121)",
      },
      math_category: {
        colour: "rgb(193, 70, 197)",
      },
      text_category: {
        colour: "rgb(253, 180, 8)",
      },
      lists_category: {
        colour: "rgb(134, 71, 254)",
      },
      robot_category: {
        colour: "rgb(111, 151, 74)",
      },
      variables_category: {
        colour: "rgb(209, 0, 35)",
      },
      kontrol_category: {
        colour: "rgb(209, 0, 35)",
      },
      motorlar_category: {
        colour: "rgb(209, 0, 35)",
      },
    },
    componentStyles: {
      workspaceBackgroundColour: "#2E3B4D",
      toolboxBackgroundColour: "#2E3B4D",
      toolboxForegroundColour: "#fff",
      flyoutBackgroundColour: "#1F2937",
      flyoutForegroundColour: "#fff",
      insertionMarkerColour: "#fff",
      flyoutOpacity: 0.75,
      scrollbarColour: "#1e1e1e",
      scrollbarOpacity: 0.6,
    },
    fontStyle: {},

    startHats: false,
  };
};

export const RidersLight: any = (isZelos: boolean) => {
  return {
    name: "riders-light",
    base: isZelos ? Blockly.Themes.Zelos : Blockly.Themes.Classic,

    blockStyles: isZelos
      ? {
          math_blocks: {
            colourPrimary: "rgb(193, 70, 197)",
            colourSecondary: "rgb(187, 49, 189)",
            colourTertiary: "rgb(187, 49, 189)",
          },
        }
      : {},
    categoryStyles: {
      logic_category: {
        colour: "rgb(61, 128, 254)",
      },
      boolean_category: {
        colour: "rgb(61, 128, 254)",
      },
      loops_category: {
        colour: "rgb(29, 178, 121)",
      },
      math_category: {
        colour: "rgb(193, 70, 197)",
      },
      text_category: {
        colour: "rgb(253, 180, 8)",
      },
      lists_category: {
        colour: "rgb(134, 71, 254)",
      },
      robot_category: {
        colour: "rgb(111, 151, 74)",
      },
      variables_category: {
        colour: "rgb(209, 0, 35)",
      },
      kontrol_category: {
        colour: "rgb(209, 0, 35)",
      },
      motorlar_category: {
        colour: "rgb(209, 0, 35)",
      },
    },
    componentStyles: {
      workspaceBackgroundColour: isZelos ? "#fff" : "#1e1e1e",
      toolboxBackgroundColour: isZelos ? "#fff" : "#333",
      toolboxForegroundColour: "#000",
      flyoutBackgroundColour: "#ddd",
      flyoutForegroundColour: "#000",
      flyoutOpacity: 0.75,
      scrollbarColour: "#1e1e1e",
      scrollbarOpacity: 0.6,
    },
    fontStyle: {},

    startHats: false,
  };
};
